export const appImages = {
  LOGO: 'https://art-bharat-web.vercel.app/assets/logo-F6sGZr7q.svg'
}
